import firebase from '../../../firebase'

export const logout = () => (dispach) => {

  return firebase
    .auth()
    .signOut()

    .then(() => {

      return dispach({
        type: 'completelogout'
      })

    })

    .then(() => {

      window.location.reload()
    })

}


// WEBPACK FOOTER //
// ./src/Components/Settings/actions/index.js